import * as ko from "knockout";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import guid from "./../../factories/guid";
import TabPage from "./../../factories/tab-page";
import BaoRouter from "./../../services/bao-router";
import Bao from "./../../services/bao-service";
import ItemAuditDialog from "../../../projectx/factories/base-audit-dialog";


class ConfigurationItemReferenceDocumentTabModel extends ChildTabViewModel {
    private _subs: KnockoutSubscription[] = [];
    private _msgCancel = Bao.Session.GetMessage("msgCancel");
    private _msgOk = Bao.Session.GetMessage("msgOk");
    private OriginalTabTitle;
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.TabPage = tabPage;
        this.ConfigurationItem = parent;
        this.OriginalTabTitle = this.TabPage.Title();
        this.TotalRows.subscribe((value) => {
            if (value == null || value == 0) {
                this.TabPage.Title(this.OriginalTabTitle);
                return;
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + value + ")");
        });
        this._subs.push(this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        }));
        this._subs.push(this.Sorting.subscribe(() => {
            this.RefreshGrid();
        }));
        this._subs.push(this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        }));
        this._subs.push(this.SelectedReferenceDocumentRow.subscribe(() => {
            this.ToggleToolbarButtons();
        }));
        this.InitializeDialogs();
    }
    ConfigurationItem: any;
    TabPage: TabPage;
    Dialog: BaoDialogViewModel = new BaoDialogViewModel(Bao.Session.ApplicationName);
    LinkDialog: BaoDialogViewModel = new BaoDialogViewModel(Bao.Session.ApplicationName);
    Bao = Bao;
    PageIndex = ko.observable<number>(0);
    PageSize = ko.observable<number>(10);
    TotalRows = ko.observable<number>(0);
    Sorting = ko.observableArray<any>();
    ReferenceDocumentCollection = ko.observableArray<any>([]);
    ToolbarButtons = ko.observableArray<any>([]);
    SelectedReferenceDocumentRow = ko.observable<any>({});
    CompleteCheck() {
        return true;
    }
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddConfigurationItemReferenceDocument":
                this.ShowConfigurationItemReferenceDocumentDialog(this.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "AddConfigurationItemLink":
                this.ShowConfigurationItemLinkDialog(this.ConfigurationItem.ConfigurationItemId(), null);
                break;
            case "EditConfigurationItemReferenceDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    if (this.SelectedReferenceDocumentRow().DocumentType === 1) {
                        this.ShowConfigurationItemLinkDialog(this.ConfigurationItem.ConfigurationItemId(), this.SelectedReferenceDocumentRow().OpenData);
                    }
                    else {
                        this.ShowConfigurationItemReferenceDocumentDialog(this.ConfigurationItem.ConfigurationItemId(), this.SelectedReferenceDocumentRow().OpenData);
                    }
                }
                break;
            case "DeleteConfigurationItemReferenceDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.DeleteConfigurationItemReferenceDocument(this.ConfigurationItem.ConfigurationItemId(), this.SelectedReferenceDocumentRow().OpenData);
                }
                break;
            case "DownloadConfigurationItemReferenceDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.DownloadConfigurationItemReferenceDocument(this.ConfigurationItem.ConfigurationItemId(), this.SelectedReferenceDocumentRow().OpenData);
                }
                break;
            case "ConfigurationItemReferenceDocumentAuditTrail":
                this.ShowAuditTrail();
                break;
        }
    };
    InitializeDialogs() {
        this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.Dialog.Width("450px");
        this.Dialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.Dialog.ViewModel().DocumentName()) &&
                    !Bao.Utils.String.IsNullOrEmpty(this.Dialog.ViewModel().Class())) {
                    this.Dialog.IsLoading(true);
                    let item = this.Dialog.ViewModel();
                    let isEdit = item.IsEdit;
                    $.when(this.Dialog.ViewModel().Upload()).then(() => {
                        let defs = [];
                        ko.utils.arrayForEach(item.DocumentIds(), (id, index) => {
                            let i = ko.map.toJS(item);
                            i.ConfigurationItemReferenceDocumentId = id;
                            i.PrimaryKeyValue = id;
                            i.SimpleSearchId = id;
                            if (isEdit) {
                                i.DocumentName = ko.unwrap(item.DocumentName);
                            }
                            else {
                                i.DocumentName = i.SelectedFiles[index];
                            }
                            defs.push(this.AddConfigurationItemReferenceDocument(i, this.ConfigurationItem.ConfigurationItemId()));
                        });
                        $.when.apply(this, defs).then(() => {
                            this.Dialog.IsLoading(false);
                            this.Dialog.Close();
                        });
                    });
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgCancel, () => { this.Dialog.Close(); })
        ]);

        this.LinkDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.LinkDialog.Width("450px");
        this.LinkDialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.LinkDialog.ViewModel().DocumentName()) &&
                    !Bao.Utils.String.IsNullOrEmpty(this.LinkDialog.ViewModel().Link()) &&
                    !Bao.Utils.String.IsNullOrEmpty(this.LinkDialog.ViewModel().Class())) {
                    this.LinkDialog.IsLoading(true);
                    let item = this.LinkDialog.ViewModel();
                    let model = ko.map.toJS(item);
                    this.AddConfigurationItemReferenceDocument(model, this.ConfigurationItem.ConfigurationItemId()).then(() => {
                        this.LinkDialog.IsLoading(false);
                        this.LinkDialog.Close();
                    });
                } else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgCancel, () => { this.LinkDialog.Close(); })
        ]);
    }
    /**
    * Dialog f�r den Audit Trail
    */
    ShowAuditTrail() {
        let getCollectionUrl = "ConfigurationItemTab/ShowReferenceDocumentAuditTrail";
        let parentId = this.ConfigurationItem.ConfigurationItemId();
        let isOverview = true;
        let customFiler = ko.observable<any>({});

        if (this.SelectedReferenceDocumentRow() != null && this.SelectedReferenceDocumentRow() != null) {
            customFiler = ko.observable<any>({ "ItemId": this.SelectedReferenceDocumentRow().OpenData });
            isOverview = false;
        }

        let auditDialog = new ItemAuditDialog(parentId, ko.unwrap(this.TabPage.Title), this.TabPage, getCollectionUrl, isOverview);
        auditDialog.CustomFilter = customFiler;

        auditDialog.Open();
    }
    RefreshGrid() {
        this.TabPage.IsLoading(true);
        var configurationItemId = this.ConfigurationItem.ConfigurationItemId();
        if (this.ConfigurationItem.IsReferenceObject() == true) {
            configurationItemId = this.ConfigurationItem.OriginalConfigurationItemId();
        }
        return Bao.post("ConfigurationItemTab/GetConfigurationItemReferenceDocumentCollection", JSON.stringify({
            sessionTabId: this.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedReferenceDocumentRow(null);
            this.TotalRows(0);
            this.ReferenceDocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.ReferenceDocumentCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
        });
    }
    AddConfigurationItemReferenceDocument(model, configurationItemId) {
        this.TabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/AddConfigurationItemReferenceDocument", JSON.stringify({
            sessionTabId: this.ConfigurationItem.TabPage.SessionTabId,
            referenceDocumentModel: ko.map.toJS(model),
            configurationItemId: configurationItemId
        }), () => {
            this.ConfigurationItem.TabPage.DirtyFlag(true);
            return this.RefreshGrid();
        });
    }
    DeleteConfigurationItemReferenceDocument(configurationItemId, configurationItemReferenceDocumentId) {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemReferenceDocument"), "yesno");
        this._subs.push(questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                return Bao.post("ConfigurationItemTab/DeleteConfigurationItemReferenceDocument", JSON.stringify({
                    sessionTabId: this.ConfigurationItem.TabPage.SessionTabId,
                    configurationItemId: configurationItemId,
                    configurationItemReferenceDocumentId: configurationItemReferenceDocumentId
                }), () => {
                    this.ConfigurationItem.TabPage.DirtyFlag(true);
                    this.RefreshGrid();
                });
            }
        }));
    }
    DownloadConfigurationItemReferenceDocument(configurationItemId, configurationItemReferenceDocumentId) {
        BaoRouter.setHash("document/" + configurationItemReferenceDocumentId);
    }
    ShowConfigurationItemReferenceDocumentDialog(configurationItemId, configurationItemReferenceDocumentId) {
        this.InitializeDialogs();
        return Bao.post("ConfigurationItemTab/ShowConfigurationItemReferenceDocumentDialog", JSON.stringify({
            sessionTabId: this.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemReferenceDocumentId: configurationItemReferenceDocumentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.Upload = function () { };
            vm.SelectedFiles = ko.observableArray<string>();
            vm.IsEdit = configurationItemReferenceDocumentId != null;
            vm.DocumentType = ko.observable(0); // sets the document type to file
            vm.SelectedFiles.subscribe((newIds) => {
                let ids = [vm.ConfigurationItemReferenceDocumentId()];
                if (newIds != null) {
                    ko.utils.arrayForEach(newIds, (id, index) => {
                        if (index > 0) {
                            ids.push(guid());
                        }
                    });
                }
                vm.DocumentIds(ids);
            });
            vm.DocumentIds = ko.observableArray<string>();
            if (vm.IsEdit) {
                vm.DocumentIds([configurationItemReferenceDocumentId]);
            }
            vm.UploadUrl = ko.computed(() => {
                let s = "";
                ko.utils.arrayForEach(vm.DocumentIds(), (id) => {
                    if (s != "") {
                        s = s + ";";
                    }
                    s = s + id;
                });
                return 'ConfigurationItemTab/UploadReferenceDocument?configurationItemReferenceDocumentIds=' + s;
            });
            this.Dialog.ViewModel(vm);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
        });
    }

    ShowConfigurationItemLinkDialog(configurationItemId, configurationItemReferenceDocumentId) {
        return Bao.post("ConfigurationItemTab/ShowConfigurationItemReferenceDocumentDialog", JSON.stringify({
            sessionTabId: this.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemReferenceDocumentId: configurationItemReferenceDocumentId
        }),
            (value) => {
                var vm = ko.map.fromJS(value.Model);
                vm.IsEdit = configurationItemReferenceDocumentId != null;
                vm.DocumentType = ko.observable(1); // sets the document type to link

                this.LinkDialog.ViewModel(vm);
                this.LinkDialog.Template(value.Message);
                this.LinkDialog.Open();
            });
    }

    ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            switch (button.ActionKey()) {
                case "AddConfigurationItemReferenceDocument":
                    if (this.ConfigurationItem.IsReferenceObject() == true) {
                        button.Enabled(false);
                    }
                    else {
                        button.Enabled(true);
                    }
                    break;
                case "EditConfigurationItemReferenceDocument":
                case "DeleteConfigurationItemReferenceDocument":
                    if (this.ConfigurationItem.IsReferenceObject() == true) {
                        button.Enabled(false);
                    }
                    else {
                        button.Enabled(!(this.SelectedReferenceDocumentRow() == null));
                    }
                    break;
                case "DownloadConfigurationItemReferenceDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow().DocumentType === 0);
                    break;
            }
        });
    }
    Refresh() {
        var def = $.Deferred();
        Bao.post("ConfigurationItemTab/ResetConfigurationItemReferenceDocument", JSON.stringify({
            sessionTabId: this.ConfigurationItem.TabPage.SessionTabId
        }), () => {
            this.RefreshGrid().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    Save() {
        return Bao.post("ConfigurationItemTab/SaveConfigurationItemReferenceDocumentCollection", JSON.stringify({
            sessionTabId: this.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: this.ConfigurationItem.ConfigurationItemId(),
            saveTime: this.ConfigurationItem.SaveTime()
        }));
    }
    loaded() {
        return this.Refresh();
    }
}
export default ConfigurationItemReferenceDocumentTabModel;